import { defineFlag } from '~/lib/featureFlags/helpers'

/**
 * Register a flag once: its GrowthBook key, its default, and the attributes it is
 * targeted on. Components read flags with `useFeatureFlagEnabled(FeatureFlag.X, ...)`
 * (boolean flags) or `useFeatureFlagValue` and never pass a raw key or a default.
 */
export const FeatureFlag = {
  DropAndHook: defineFlag({
    key: 'drop-and-hook',
    default: false,
    attributes: ['costCenterCode'],
  }),
  DropAndHookVersatility: defineFlag({
    key: 'drop-and-hook-versatility',
    default: false,
    attributes: ['costCenterCode'],
  }),
  EnableGrowthAlpha: defineFlag({
    key: 'enable-growth-alpha',
    default: false,
  }),
  EnableRequestTraining: defineFlag({
    key: 'enable-request-training',
    default: false,
  }),
}
